import { FC } from 'react';
// component
import AddStaffComponent from 'components/main/Staff/Add';

const AddStaff: FC = () => <AddStaffComponent />;

export default AddStaff;
